<template>
  <div class="client_request_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">

      <div class="selects">
        <div class="form_select">
          <label> {{ translate("client_request.request_type") }} </label>
          <tree-select
              :options="request_type_list"
              :multiple="false"
              v-model="filter.request_type"
              :placeholder="translate('client_request.request_type')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.iccid"
              :placeholder="translate('client_request.simcard_list.iccid')"
              :label="translate('client_request.simcard_list.iccid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="selects">
        <div class="form_select">
          <label> {{ translate("client_request.request_status") }} </label>
          <tree-select
              :options="request_status_list"
              :multiple="false"
              v-model="filter.request_status"
              :placeholder="translate('client_request.request_status')"
              :clearable="true"
              @input="change_input"
          />
        </div>


        <div class="form_select">
          <label> {{ translate("client_request.simcard_list.oper_name") }} </label>
          <tree-select
              :options="mno_list"
              :multiple="false"
              v-model="filter.mno_id"
              :placeholder="translate('client_request.simcard_list.oper_name')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="selects">
        <div class="form_select">
          <WrapDatePicker
              type="date"
              :placeholder="translate('client_request.period')"
              :label="translate('client_request.period')"
              v-model="filter.date"
              :range="true"
              :confirm="true"
              value_type="YYYY-MM-DD"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <label> {{ translate("client_request.simcard_list.status_profile") }} </label>
          <tree-select
              :options="simcard_profile_status_list"
              :multiple="false"
              v-model="filter.simcard_profile_status"
              :placeholder="translate('client_request.simcard_list.status_profile')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="selects">
        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.fid"
              :placeholder="translate('client_request.device_fid')"
              :label="translate('client_request.device_fid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="selects"></div>

      <div class="selects">
        <div class="form_select">
          <span
              class="btn btn-fill btn-warning"
              @click="reset_filter"
          >
            {{ translate("filter.reset") }}
          </span>
        </div>

        <div class="form_select">
          <span
              class="btn btn-fill btn-warning"
              @click="show_modal"
          >
            {{ translate("client_request.prepare_activation_list") }}
          </span>
        </div>

        <div class="form_select">
          <span
              class="btn btn-fill btn-info"
              @click="copy_iccid"
          >
            {{ translate("client_request.copy_iccid") }}
          </span>
        </div>
        <div class="form_select">
          <span
              class="mdi mdi-plus-circle-outline btn btn-fill btn-success"
              @click.prevent="create_sim_task"
          >
            {{ translate('sim_task_list.task_list.create_sim_task') }}
          </span>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("client_request.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer"
                @click="change_filter('request_type')"
                :class="{ selected: filter_type === 'request_type' }"
                scope="col"
            >
              {{ translate('client_request.request_type') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('request_status')"
                :class="{ selected: filter_type === 'request_status' }"
                scope="col"
            >
              {{ translate('client_request.request_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('device_name')"
                :class="{ selected: filter_type === 'device_name' }"
                scope="col"
            >
              {{ translate('client_request.device_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('oper_name')"
                :class="{ selected: filter_type === 'oper_name' }"
                scope="col"
            >
              {{ translate('client_request.simcard_list.oper_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'asc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('msisdn')"
                :class="{ selected: filter_type === 'msisdn' }"
                scope="col"
            >
              {{ translate('client_request.simcard_list.msisdn') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'asc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('imsi')"
                :class="{ selected: filter_type === 'imsi' }"
                scope="col"
            >
              {{ translate('client_request.simcard_list.imsi') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('iccid')"
                :class="{ selected: filter_type === 'iccid' }"
                scope="col"
            >
              {{ translate('client_request.simcard_list.iccid') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('profile_status')"
                :class="{ selected: filter_type === 'profile_status' }"
                scope="col"
            >
              {{ translate('client_request.simcard_list.status_profile') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('ts_update')"
                :class="{ selected: filter_type === 'ts_update' }"
                scope="col"
            >
              {{ translate('client_request.updated') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <ClientRequestListItem
              v-for="(simcard,key) in simcard_list"
              :key="key"
              :client_simcard_request="simcard"
              @add_in_filter="add_in_filter"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ClientRequestListItem from "./Item/Index.vue";
import ActivationListsModal from "./Modal/ActivationListsModal.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import CreateSimTask from "components/UIComponents/SimTask/CreateSimTask.vue";

export default {
  name: 'ClientRequestSimcardList',
  components: {
    WrapDatePicker,
    ClientRequestListItem
  },
  data () {
    return {
      client_request_list: [],
      client_request_statuses: [],
      check_link: true,
      filter:{
        date: [],
        fid: "",
        iccid: "",
        request_type: null,
        request_status: null,
        mno_id: null,
        simcard_profile_status: null,
      },
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    simcard_list(){
      let simcard_list = [...this.client_request_list];
      return simcard_list.sort(this.compareNumbers);
    },
    request_type_list(){
      return this.$store.getters.getClientRequestsInfo.types.map((entry) => {
        return { id: Number(entry.id), label: this.translate("client_request.types." + entry.title) }
      })
    },
    request_status_list() {
      return this.$store.getters.getClientRequestsInfo.statuses.map((entry) => {
        return { id: Number(entry.id), label: this.translate("client_request.statuses." + entry.title) }
      })
    },
    mno_list() {
      return this.$store.getters.getSimcardMno.map((mno) => {
        return { id: mno.id, label: mno.title }
      })
    },
    simcard_profile_status_list() {
      return this.$store.getters.getSimcardProfileStatuses.map((status) => {
        if (status.id !== -1){
          return { id: status.id, label: this.translate("simcard_profile.statuses." + status.title) }
        }
      }).filter((element) => { return element !== undefined })
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'client_request_list_section') {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'iccid':
              case 'fid':
              case 'request_type':
              case 'request_status':
              case 'mno_id':
              case 'simcard_profile_status':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += `&${key}=${this.filter[key]}`
                }
                break;
            }
          }
          history.replaceState(null, null, this.$route.path + string)
        }
      }
    },
    "filter.status":{
      handler(){
        this.filter.only_active = this.filter.status < 0;
      }
    },
    "filter.fid":{
      handler(){
        this.filter.fid = this.filter.fid.replace(" ", "")
      }
    },
  },
  created () {
    this.check_query()
  },
  deactivated() {
    this.filter = {
      date: [],
      fid: "",
      iccid: "",
      request_type: null,
      request_status: null,
      mno_id: null,
      simcard_profile_status: null,
    }
  },

  methods: {
    reset_filter(){
      this.filter = {
        date: [],
        fid: "",
        iccid: "",
        request_type: null,
        request_status: null,
        mno_id: null,
        simcard_profile_status: null,
      }
    },
    create_sim_task(){
      let t = this.$createElement(CreateSimTask, {
        props: {
          simcards: this.simcard_list
        },
        on: {
          close: () => {
            this.$modal.hide('create_sim_task')
          },
          update: () => {
            this.$modal.hide('create_sim_task')
            this.load_client_requests()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'create_sim_task'
      })
    },
    copy_iccid(){
      let string = ""
      this.simcard_list.forEach((item, key) => {
        string += `${item.iccid}\t`

        if (key !== this.simcard_list.length - 1){
          string += `\r`
        }
      })
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    show_modal(){
      let lists = {}
      this.simcard_list.forEach((item) => {
        if (!lists[item.oper_name]){
          lists[item.oper_name] = []
        }
        lists[item.oper_name].push(item)
      })

      let t = this.$createElement(ActivationListsModal, {
        props: {
          lists
        },
        on: {
          close: () => {this.$modal.hide('activation_lists_modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'activation_lists_modal'})
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'iccid':
            case 'fid':
              this.filter[key] = this.$route.query[key]
              break;
            case 'request_type':
            case 'request_status':
            case 'mno_id':
            case 'simcard_profile_status':
              this.filter[key] = Number(this.$route.query[key])
              break;
          }
        }
      }
      this.load_client_requests()
    },
    add_in_filter(params){
      this.filter[params.type] = params.value
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_client_requests, 500)
    },
    load_client_requests(){
      let filter = {}
      Object.keys(this.filter).forEach((key) => {
        if (key === "date"){
          if (this.filter[key].length > 0 && this.filter[key][0] !== null && this.filter[key][1] !== null){
            filter.date_start = this.filter[key][0]
            filter.date_end = this.filter[key][1]
          }
        } else {
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      })

      this.$http.v1.getClientRequestSimcardList(filter, (response) => {
        if (response.data){
          this.client_request_list = response.data.data
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.client_request_list{
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;

  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .selects{
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
      .form_select{
        .btn{
          width: 100%;
          padding: 0;
        }
      }
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
    }
  }

  .client_request{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    flex: 10;
    padding: 10px 0 0;
    table{
      tbody{
        .online{
          color: #15ab00;
        }
        span{
          font-size: 22px;
        }
      }
      th {
        &.limit{
          width: 10%;
          min-width: 100px;
        }
        &.device_status{
          width: 120px;
        }
        &.device_tariff{
          width: 120px;
        }
      }
    }
  }
}


@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
  }

}
</style>
